import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import {
  and,
  collection,
  deleteDoc,
  doc,
  endBefore,
  getDocs,
  limit,
  limitToLast,
  or,
  orderBy,
  query,
  startAfter,
  Timestamp,
  where,arrayRemove,updateDoc
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import CommonHeadings from "helper/constant/headings";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import AddButton from "components/buttons/addbutton";
import ListHeadingComponent from "components/headingComponent/listHeading";
import Swal from "sweetalert2";
import Moment from "react-moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dateformat from "helper/constant/timeFormat";
import Constant from "helper/constant/constant";

import moment from "moment";
import * as XLSX from "xlsx";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { ButtonGroup } from "react-bootstrap";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import WhatsAppConfig from "helper/config/whatsappConfig";

const TeachersList = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [teachersData, setTeachersData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  //these are pagination variables
  const [filteredDates, setFilteredDates] = useState(null);
  const [page, setPage] = useState(0);
  const [isNext, setIsNext] = useState(false);


  const tabsData = [
    { id: 1, label: "Active" },
    { id: 2, label: "Leave" },
  ];

  const [activeTab, setActiveTab] = useState(tabsData[0].id);

  // Message modal state
  const [messageModalVisible, setMessageModalVisible] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [isSendingMessage, setIsSendingMessage] = useState(false);

  // tabs are active
  const handleTabClick = async (id) => {
    setActiveTab(id);
    fetchTeachersApi(id);
  };

  // MARK: use Effect function
  useEffect(() => {
    fetchTeachersApi(activeTab);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.teacherListHeading;
  }, []);

  // MARK:  function using in input
  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };

  // MARK: Edit data function
  const tapOnEdit = (teacherData) => () => {
    navigate(RoutingPaths.editTeachers, { state: teacherData });
  };

  // MARK: Delete data function
  const tapOnDeleteConfirm = (teacher) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this teacher data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteTeachersApi(teacher);
      }
    });
  };

  async function deleteSingleTeacherRecord(teacher) {
    let expenseQuery = query(collection(dbFirestore, TableName.salaryExpenses), where("teacher_id", "==", teacher.id));
    const expenseSnapshot = await getDocs(expenseQuery);
    expenseSnapshot.forEach((doc) => {
      deleteDoc(doc.ref);
    });

    let attendanceQuery = query(collection(dbFirestore, TableName.teacherAttendance), where("attendance", "array-contains", teacher.id));
    const attendanceSnapshot = await getDocs(attendanceQuery);
      
        attendanceSnapshot.forEach(async (doc) => {
          await updateDoc(doc.ref, {
            attendance: arrayRemove(teacher.id)
          });
        });
  }


  // MARK: delete API
  const deleteTeachersApi = async (teacher) => {
    deleteSingleTeacherRecord(teacher);

    await deleteDoc(doc(dbFirestore, TableName.teachers, teacher.id));
    setTeachersData((prevState) =>
      prevState.filter((el) => el.id !== teacher.id)
    );
    toast.success(ToastMessages.teachersDeleted);
  };

  // MARK: view data function
  const tapOnView = (TeachersData) => () => {
    navigate(RoutingPaths.viewTeachers, { state: TeachersData });
  };

  // message button - open modal
  const tapOnMessage = (teacherModel) => () => {
    setSelectedTeacher(teacherModel);
    setMessageText("");
    setMessageModalVisible(true);
  };

  // close message modal
  const hideMessageModal = () => {
    setMessageModalVisible(false);
    setSelectedTeacher(null);
    setMessageText("");
  };

  // send WhatsApp message
  const sendWhatsAppMessage = async () => {
    if (!messageText.trim()) {
      toast.error("Please enter a message");
      return;
    }

    if (!selectedTeacher?.contact_no) {
      toast.error("Teacher contact number not available");
      return;
    }

    setIsSendingMessage(true);

    try {
      // Format phone number (remove spaces, dashes, and ensure it has country code)
      let phoneNumber = selectedTeacher.contact_no.replace(/[\s-]/g, "");
      if (!phoneNumber.startsWith("91")) {
        phoneNumber = "91" + phoneNumber;
      }

      const encodedMessage = encodeURIComponent(messageText);
      const url = `${WhatsAppConfig.baseUrl}?number=${phoneNumber}&type=text&message=${encodedMessage}&instance_id=${WhatsAppConfig.instanceId}&access_token=${WhatsAppConfig.accessToken}`;

      await fetch(url, { mode: "no-cors" });
      toast.success("Message sent successfully!");
      hideMessageModal();
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSendingMessage(false);
    }
  };

  // MARK:  reset button function
  const tapOnResetButton = () => {
    setFilteredDates(null);
    fetchTeachersApi(activeTab);
  };

  // MARK: fetch teacher API
  async function fetchTeachersApi(id) {
    let q = query(
      collection(dbFirestore, TableName.teachers), where("status", "==", id === 1 ? "active" : "leave"),
      orderBy("created_at", "desc"),
      limit(Constant.perPage)
    );
    const querySnapshot = await getDocs(q);
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    setTeachersData(array);
    setLoading(false);
    setPage(0);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
      const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

      const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
      const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  // MARK: filter function using in input
  const tapOnFilterButton = async () => {
    const querySnapshot = await createQueryForTable();
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
    setTeachersData(array);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  async function createQueryForTable() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.teachers),
        where("joining_date_num", ">=", getFilteredDatesTimeStamp().startTime),
        where("joining_date_num", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage), orderBy("created_at", "desc")
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.teachers), where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("created_at", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }


  async function createQueryForExport() {
    const filterText = filteredDates;
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.teachers),
        where("joining_date_num", ">=", getFilteredDatesTimeStamp().startTime),
        where("joining_date_num", "<=", getFilteredDatesTimeStamp().endTime),
        orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.teachers), where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("created_at", "desc"),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }


  // MARK: serach api
  const searchTeachersApi = async (e) => {
    const searchText = e.target.value.toLowerCase();

    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.teachers),
        or(
          and(
            where("name", ">=", searchText),
            where("name", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "name",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "name",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "name",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "name",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          )
        )
      );
      const querySnapshot = await getDocs(q);

      // set data from docs
      setTeachersData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
    } else {
      fetchTeachersApi(activeTab);
    }
  };

  // MARK: pagination code
  const showNext = ({ item }) => {
    const fetchNextData = async () => {
      var paginationQuery;

      paginationQuery = query(
        collection(dbFirestore, TableName.teachers),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at)
      );

      const querySnapshot = await getDocs(paginationQuery);

      setTeachersData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (teachersData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  // MARK: previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.teachers),
      orderBy("created_at", "desc"),
      endBefore(teachersData[0].created_at),
      limitToLast(Constant.perPage)
    );
    const querySnapshot = await getDocs(paginationQuery);

    setTeachersData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // MARK: condition while selecting the previous button
  const showPrevious = () => {
    if (teachersData.length === 0) {
      fetchTeachersApi(activeTab);
    } else {
      fetchPreviousData();
    }
  };


  //MARK: Search UI
  const searchBar = () => {
    return (
      <>
        <div className="tabs" style={{ marginBottom: "1rem" }}>
          {tabsData.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="search__main_div" style={{ justifyContent: "end" }}>
          <div className="me-2">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                type="search"
                value={globalFilterValue}
                onChange={searchTeachersApi}
                placeholder="Search by name"
              />
            </IconField>
          </div>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select start and end date"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  // MARK: columns data
  const columns = [
    {
      field: "name",
      header: "Name",
      className: "table__column__capital",
    },
    { field: "contact_no", header: "Contact Number" },
    {
      field: "joining_date",
      header: "Joining Date",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYY}>{data.joining_date}</Moment>
      ),
    },
    { field: "salary", header: "Salary", CardBody: priceBodyTemplate },
    {
      field: "actions",
      header: "Actions",
      CardBody: (data) => (
        <>
          <div className="d-flex mt-3 text-start">
            <Button
              type="button"
              className="lists__edit_button"
              onClick={tapOnEdit(data)}
              tooltip="edit"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-pencil"></span>
            </Button>

            <Button
              type="button"
              className="lists__edit_button"
              onClick={tapOnView(data)}
              tooltip="view"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-eye"></span>
            </Button>

            <Button
              type="button"
              className="lists__edit_button"
              onClick={tapOnMessage(data)}
              tooltip="message"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-comments"></span>
            </Button>

            <Button
              severity="secondary"
              type="button"
              onClick={tapOnDeleteConfirm(data)}
              className="lists__delete_button"
              tooltip="delete"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-trash"></span>{" "}
            </Button>
          </div>
        </>
      ),
    },
  ];

  // MARK: modify teacher model in which we add new inputs in an array
  const modifyTeacherModel = (teacherModal) => {
    teacherModal.date_joining = moment(teacherModal.joining_date).format(
      Dateformat.YYYYMMDD
    );
    teacherModal.created_at = moment(teacherModal.created_at).format(
      Dateformat.YYYYMMDD
    );
    return teacherModal;
  };

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();

        const mylist = querySnapShot.docs.map((model) => modifyTeacherModel(model));

        const filterUserData = mylist.map(
          ({ name, contact_no, salary, date_joining, department,
            designation, created_at }) => ({
              teacher_name: name,
              contact_no: contact_no,
              joining_date: date_joining,
              salary: salary,
              department: department,
              designation: designation,
              created_at: created_at,
            })
        );
        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(filterUserData);
          XLSX.utils.book_append_sheet(workBook, workSheet, "teacher");
          XLSX.writeFile(workBook, "teacher_data.xlsx");
        } else {
          toast.error(ToastMessages.filterDate);
        }
      }
    });
  };

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.teacherListHeading}
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addTeachers} />
          </div>

          <DataTable
            className="mt-5 mb-3"
            value={teachersData}
            header={header}
            emptyMessage="No data found."
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>
          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({ item: teachersData[teachersData.length - 1] })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>

      {/* WhatsApp Message Modal */}
      <Dialog
        header={`Send Message to ${selectedTeacher?.name || "Teacher"}`}
        visible={messageModalVisible}
        style={{ width: "450px" }}
        onHide={hideMessageModal}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={hideMessageModal}
              className="list__reset_button"
            />
            <Button
              label={isSendingMessage ? "Sending..." : "Send"}
              icon="pi pi-send"
              onClick={sendWhatsAppMessage}
              disabled={isSendingMessage}
              className="list__filter_button"
            />
          </div>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="teacherNumber" className="mb-2 d-block">
              <strong>Contact Number:</strong> {selectedTeacher?.contact_no || "N/A"}
            </label>
          </div>
          <div className="field mt-3">
            <label htmlFor="message" className="mb-2 d-block">
              <strong>Message:</strong>
            </label>
            <InputTextarea
              id="message"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              rows={5}
              placeholder="Type your message here..."
              autoResize
            />
          </div>
        </div>
      </Dialog>
      <ToastContainer />
    </div>
  );
};

const priceBodyTemplate = (teacher) => {
  return `Rs ${teacher.salary_num?.toLocaleString()}`;
};

export default TeachersList;
